import React from "react";
import { Controller, useForm } from "react-hook-form";
import {
  LeadAssignmentSettings,
  AccountType,
} from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { Multiselect } from "react-widgets";
import { convertPascalCaseToWords } from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: LeadAssignmentSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: LeadAssignmentSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<LeadAssignmentSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderCrmAgentTypesy = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Support Executive<span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="crmAgentTypes"
                defaultValue={props.data?.crmAgentTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Support Executive"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.crmAgentTypes && (
                <ErrorMessage>
                  Support Executive Types is required
                </ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderSalesPersonTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Transaction Manager Types<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="salesPersonTypes"
                defaultValue={props.data?.salesPersonTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Transaction Manager Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.salesPersonTypes && (
                <ErrorMessage>Transaction Manager Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderLeadAssigneeHeadTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">City Head<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="leadAssigneeHeadTypes"
                defaultValue={props.data?.leadAssigneeHeadTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select City Head Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.leadAssigneeHeadTypes && (
                <ErrorMessage>City Head Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLeadManagerTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Lead Manager<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="leadManagerTypes"
                defaultValue={props.data?.leadManagerTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Lead Manager Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.leadManagerTypes && (
                <ErrorMessage>Lead Manager Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderGroupManagerTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Group Manager<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="groupManagerTypes"
                defaultValue={props.data?.groupManagerTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Group Manager Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.groupManagerTypes && (
                <ErrorMessage>Group Manager Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTeleCallerTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Telecaller<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="teleCallerTypes"
                defaultValue={props.data?.teleCallerTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "SupportExecutive" : key === "Agent" ?
                            "TransactionManager" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Telecaller Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.teleCallerTypes && (
                <ErrorMessage>Telecaller Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Lead Distribution Settings
        </h4>
        <div className="row gutter-10">
          {renderLeadManagerTypes()}
          {renderGroupManagerTypes()}
          {renderTeleCallerTypes()}
          {renderCrmAgentTypesy()}
          {renderSalesPersonTypes()}
          {renderLeadAssigneeHeadTypes()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
